import React from "react";
import axios from "axios";
import BeerItemDisplay from "./BeerItemDisplay";

interface Beer {
  id: number;
  name: string;
  brewery: string;
  breweryLocation: string;
  style: string;
  abv: number;
  ibu: number;
  containers: BeerContainer[];
  tapNumber: number;
  isNew: boolean;
}

export interface BeerContainer {
  name: string;
  price: number;
}

export default class BeerMenu extends React.Component {
  state = {
    beers: [] as Beer[],
  };

  refreshTimer?: NodeJS.Timer;

  refreshData = () => {
    axios({
      method: "get",
      //url: `https://localhost:7175/api/draftmenuboard`, //for local testing
      url: `https://thirtyspizza.com:8080/api/draftmenuboard`,
      headers: {},
    }).then((response) => {
      let beers = response.data
      let newDraftMenu = [] as Beer[];
      beers.forEach((beer: any) => {
        let newContainers = [] as BeerContainer[];
        newContainers.push({
          name: beer.size,
          price: beer.price,
        });
        newDraftMenu.push({
          id: beer.pk,
          name: beer.name,
          brewery: beer.brewery,
          breweryLocation: '',
          style: beer.style,
          abv: beer.abv,
          ibu: isNaN(beer.ibu) ? 0 : beer.ibu,
          containers: newContainers,
          tapNumber: beer.tapNumber,
          isNew: beer.isNew,
      })});

      newDraftMenu.sort((beerA, beerB) => beerA.tapNumber - beerB.tapNumber); //sort draft menu by tap number ascending

      this.setState({
        beers: newDraftMenu,
      });
    });
  };

  componentDidMount() {
    this.refreshTimer = setInterval(this.refreshData, 10000);
    this.refreshData();
  }

  componentWillUnmount() {
    clearInterval(this.refreshTimer);
  }

  render() {
    return (
      <div>
        <div className="columns-1 md:columns-2">
          {this.state.beers.map((beer) => (
            <BeerItemDisplay
              key={beer.id}
              id={beer.id}
              name={beer.name}
              brewery={beer.brewery}
              breweryLocation={beer.breweryLocation}
              style={beer.style}
              abv={beer.abv}
              ibu={beer.ibu}
              containers={beer.containers}
              tapNumber={beer.tapNumber}
              isNew={beer.isNew}
            />
          ))}
        </div>
        <div>
          <img
            src="https://thirtyspizza.com/images/thirtys-logo.png"
            className="object-contain h-28 mx-auto"
            alt="thirtys-logo"
          ></img>
        </div>
      </div>
    );
  }
}
